var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFocusMode = function SvgFocusMode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.5 5.25a.75.75 0 0 0-.75.75v3h1.5V6.75H9.5v-1.5zm12 0h-3v1.5h2.25V9h1.5V6a.75.75 0 0 0-.75-.75M7.25 15v2.25H9.5v1.5h-3a.75.75 0 0 1-.75-.75v-3zm10.5 0v2.25H15.5v1.5h3a.75.75 0 0 0 .75-.75v-3zM11 9.75a.75.75 0 0 0-.75.75v3c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75v-3a.75.75 0 0 0-.75-.75z"
  })));
};
export default SvgFocusMode;